import { hasCapability } from 'src/platform';
import { CONFIG } from 'src/environments/environment';
import { useSystemStore } from 'src/store/SystemStore';

/** Identity of this compiled JavaScript bundle (also used for source maps). */
export const buildAppVersion = CONFIG.VITE_APP_VERSION;

/** Safe before native detection finishes; the store starts at the build version. */
export function getCurrentAppVersion(): string {
  return useSystemStore.getState().appVersion.current;
}

/**
 * The version the backend routes requests on (`accept-version`; `/api/sales/v2`
 * needs major >= 2). The Windows POS installs under its own per-environment
 * release version, so it sends the code version of this bundle instead; every
 * other runtime sends the version it is running.
 */
export function apiAcceptVersion(current: string): string {
  return hasCapability('appVersionSource') === 'platform-shell' ? buildAppVersion : current;
}
